// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3IttS","slider":"styles_slider__2RKLC","input":"styles_input__2gDmF","round":"styles_round__1RI3i","slider2":"styles_slider2__2mbZv"};